// Shared presentational components for indicator preview (non-edit) display.
// Matches primary symbol input styling for Instrument; value pills for Period, Field, Lag, etc.

import React from 'react';

const INSTRUMENT_CLASS =
  'border-2 border-rule rounded-sm bg-newsprint-panel text-ink px-2 py-1 text-sm inline-block';

const VALUE_PILL_CLASS =
  'rounded-sm border border-rule bg-newsprint-dark text-ink px-2 py-0.5 text-xs inline-block';

export function InstrumentPill({ children }: { children: React.ReactNode }) {
  return <span className={INSTRUMENT_CLASS}>{children}</span>;
}

type ValuePillProps = {
  label?: string;
  value?: React.ReactNode;
  children?: React.ReactNode;
};

export function ValuePill({ label, value, children }: ValuePillProps) {
  const content = children ?? (label != null && value != null ? `${label}: ${value}` : value);
  if (content == null) return null;
  return <span className={VALUE_PILL_CLASS}>{content}</span>;
}

export function FromIndicatorBadge() {
  return (
    <em className="text-xs text-accent" aria-label="Series is from another indicator">
      (from indicator)
    </em>
  );
}
